import { render, staticRenderFns } from "./HeaderModule.vue?vue&type=template&id=0b0ce641&scoped=true&"
import script from "./HeaderModule.vue?vue&type=script&lang=js&"
export * from "./HeaderModule.vue?vue&type=script&lang=js&"
import style0 from "./HeaderModule.vue?vue&type=style&index=0&id=0b0ce641&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0ce641",
  null
  
)

export default component.exports